import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";

import { DOLLAR_PREFIX } from "../../constants/index";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { formatMoney } from "../../utils/numberFormatters";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const onlineRevenueDefinition = defineDescriptionFilter({
    key: "onlineRevenue",
    apiCategory: leadsFilterApiCategory.onlineRevenue,
    category: leadsFilterCategoryMap.website,
    trackingName: "E-commerce online revenue",

    render: ({ description }) =>
        createRangeSelectFilter({
            key: "onlineRevenue",
            trackingName: "E-commerce online revenue",
            apiCategory: "leadsFilters",
            category: leadsFilterCategoryMap.website,

            translationKey: "ecommerceRevenue",
            rangeOptions: {
                fieldName: "onlineRevenue",
                labelKey: leadsSearchFiltersI18nKeys.filterSummaryLabel("onlineRevenue"),
                buckets: description.bucketsDescription.onlineRevenue,
                placeholderPrefix: DOLLAR_PREFIX,
                formatValue: formatMoney,
            },
        }),
});
